export default __webpack_public_path__ + "static/media/license.c5ebce20.pdf";